const WmsCard = () => {
  const cardData = [
    {
      id: 1,
      image: "assets/img/home_37/why-card-1.png",
      title: "Vehicles",
      description:
        "Our software includes a built-in, prefilled vehicle database, eliminating the need for manual entry. Save time and get started instantly!",
    },
    {
      id: 2,
      image: "assets/img/home_37/why-card-2.png",
      title: "Services",
      description:
        "Prefilled service list with prices included, no setup needed. Start offering repairs and maintenance instantly with zero hassle!",
    },
    {
      id: 3,
      image: "assets/img/home_37/why-card-3.png",
      title: "Inventory",
      description:
        " Easily manage inventory and link items to specific vehicle models. Add, edit, or remove stock in just a few clicks, anytime.",
    },
    {
      id: 4,
      image: "assets/img/home_37/why-card-4.png",
      title: "Customers",
      description:
        "Manage customers with ease, track bookings, payments, dues & send reminders. All-in-one customer management for your garage!",
    },
    {
      id: 5,
      image: "assets/img/home_37/why-card-5.png",
      title: "Vendors",
      description:
        "Simplify vendor management, track orders, payments, and communications all in one place for seamless supplier relationships.",
    },
    {
      id: 6,
      image: "assets/img/home_37/why-card-6.png",
      title: "Employees",
      description:
        "Keep track of employee sales, performance, and tasks all in one place streamline team management with ease and efficiency.",
    },
  ];
  return (
    <>
      <section className="bg-light-subtle pt-50 pb-50">
        <div className="container">
          <div className="row g-4">
            <div className="col-xl-5">
              <div className="position-relative h-100">
                <div className="ca-card-title">
                  <div className="d-inline-block px-4 py-1 rounded-pill border border-warning mb-3">
                    <p className="ma-warning-text fw-bold mb-0">
                      What’s Inside
                    </p>
                  </div>
                  <h2 className="ail-title text-black fs-48 fw-600 mb-4">
                    Modular Features Built for Complete Control
                  </h2>
                  <p className="mb-4">
                    Our software is built with specialised modules, each
                    designed to manage a specific part of your garage, from job
                    cards and billing to inventory and reporting, ensuring
                    smooth, efficient, and fully integrated operations across
                    your business.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-xl-7">
              <div className="row g-4">
                {cardData.map((card) => (
                  <div key={card.id} className="col-md-6">
                    <div
                      className="bg-white px-4 py-4 rounded shadow-sm"
                      style={{ height: "300px" }}
                    >
                      <img
                        src={card.image}
                        alt="image"
                        className="img-fluid mb-3"
                      />
                      <h6 className="heading-6 clr-text font-weight-bold mb-3">
                        {card.title}
                      </h6>
                      <p className="mb-0">{card.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default WmsCard;
